import { portalApi } from "../../../store/generated/portal/assessments/debrief-schedules";

export enum DebriefScheduleApiTags {
  DebriefSchedules = "DebriefSchedules",
}

// Enhance the generated API with custom tags and legacy endpoint overrides if needed
const taggedApi = portalApi.enhanceEndpoints({
  addTagTypes: [DebriefScheduleApiTags.DebriefSchedules],
  endpoints: {
    // Add tag invalidation to generated endpoints
    apiPortalV1AssessmentsDebriefSchedulesList: {
      providesTags: [DebriefScheduleApiTags.DebriefSchedules],
    },
    apiPortalV1AssessmentsDebriefSchedulesRetrieve: {
      providesTags: (result, error, arg) => [
        { type: DebriefScheduleApiTags.DebriefSchedules, id: arg.id }
      ],
    },
    apiPortalV1AssessmentsDebriefSchedulesCreate: {
      invalidatesTags: [DebriefScheduleApiTags.DebriefSchedules],
    },
    apiPortalV1AssessmentsDebriefSchedulesUpdate: {
      invalidatesTags: (result, error, arg) => [
        { type: DebriefScheduleApiTags.DebriefSchedules, id: arg.id },
        DebriefScheduleApiTags.DebriefSchedules
      ],
    },
    apiPortalV1AssessmentsDebriefSchedulesPartialUpdate: {
      invalidatesTags: (result, error, arg) => [
        { type: DebriefScheduleApiTags.DebriefSchedules, id: arg.id },
        DebriefScheduleApiTags.DebriefSchedules
      ],
    },
    apiPortalV1AssessmentsDebriefSchedulesDestroy: {
      invalidatesTags: [DebriefScheduleApiTags.DebriefSchedules],
    },
    apiPortalV1AssessmentsDebriefSchedulesSendRemindersCreate: {
      invalidatesTags: [DebriefScheduleApiTags.DebriefSchedules],
    },
    apiPortalV1AssessmentsDebriefSchedulesSendRemindersToEmployeesCreate: {
      invalidatesTags: [DebriefScheduleApiTags.DebriefSchedules],
    },
  },
});

// Export the enhanced API as debriefScheduleApi for backward compatibility
export const debriefScheduleApi = taggedApi;

// Re-export all the generated hooks with the enhanced tags
export const {
  useApiPortalV1AssessmentsDebriefSchedulesListQuery,
  useApiPortalV1AssessmentsDebriefSchedulesCreateMutation,
  useApiPortalV1AssessmentsDebriefSchedulesRetrieveQuery,
  useApiPortalV1AssessmentsDebriefSchedulesUpdateMutation,
  useApiPortalV1AssessmentsDebriefSchedulesPartialUpdateMutation,
  useApiPortalV1AssessmentsDebriefSchedulesDestroyMutation,
  useApiPortalV1AssessmentsDebriefSchedulesSendRemindersCreateMutation,
  useApiPortalV1AssessmentsDebriefSchedulesSendRemindersToEmployeesCreateMutation,
} = debriefScheduleApi;

// Legacy hook aliases for backward compatibility
export const useGetDebriefSchedulesQuery = useApiPortalV1AssessmentsDebriefSchedulesListQuery;
export const useLazyGetDebriefSchedulesQuery = debriefScheduleApi.useLazyApiPortalV1AssessmentsDebriefSchedulesListQuery;
export const useGetDebriefScheduleQuery = useApiPortalV1AssessmentsDebriefSchedulesRetrieveQuery;
export const useCreateDebriefScheduleMutation = useApiPortalV1AssessmentsDebriefSchedulesCreateMutation;
export const useUpdateDebriefScheduleMutation = useApiPortalV1AssessmentsDebriefSchedulesPartialUpdateMutation;
export const useDeleteDebriefScheduleMutation = useApiPortalV1AssessmentsDebriefSchedulesDestroyMutation;
export const useSendRemindersMutation = useApiPortalV1AssessmentsDebriefSchedulesSendRemindersCreateMutation;
export const useSendRemindersToEmployeesMutation = useApiPortalV1AssessmentsDebriefSchedulesSendRemindersToEmployeesCreateMutation;
